/* Sortiert Event-Karten innerhalb eines Orts chronologisch und übernimmt auf
   Mobile die lückenlose Halb-/Vollbreiten-Anordnung der Homepage-Kacheln. */
(function () {
  var phoneMedia = window.matchMedia('(max-width: 950px)');
  var tileFormats = [
    { width: 217, ratio: 217 / 290 },
    { width: 290, ratio: 1 },
    { width: 388, ratio: 388 / 290 }
  ];

  function closestTileFormat(sourceRatio) {
    return tileFormats.reduce(function (closest, format) {
      return Math.abs(format.ratio - sourceRatio) < Math.abs(closest.ratio - sourceRatio)
        ? format
        : closest;
    });
  }

  function applyTileFormat(card, sourceRatio) {
    if (!sourceRatio || !isFinite(sourceRatio) || sourceRatio <= 0) return false;
    var format = closestTileFormat(sourceRatio);
    var currentFormat = Number(card.getAttribute('data-event-format'));

    tileFormats.forEach(function (candidate) {
      card.classList.remove('event-card--w' + candidate.width);
    });
    card.classList.add('event-card--w' + format.width);
    card.setAttribute('data-event-format', String(format.width));
    return currentFormat !== format.width;
  }

  /* Identisch zur Homepage: Eine passende halbbreite Partnerkarte wird vor
     die nächste Vollbreitenkarte gezogen. So bleibt keine halbe Reihe leer. */
  function compactMobileTileOrder(items) {
    var remaining = items.slice();
    var ordered = [];

    while (remaining.length) {
      var item = remaining.shift();
      var isWide = item.classList.contains('event-card--w388');

      if (isWide) {
        ordered.push(item);
        continue;
      }

      var partnerIndex = remaining.findIndex(function (candidate) {
        return !candidate.classList.contains('event-card--w388');
      });

      if (partnerIndex === -1) {
        ordered = ordered.concat(remaining, item);
        break;
      }

      var partner = remaining.splice(partnerIndex, 1)[0];
      ordered.push(item, partner);
      if (partnerIndex > 0) ordered = ordered.concat(remaining.splice(0, partnerIndex));
    }

    return ordered;
  }

  document.querySelectorAll('[data-event-sort-list]').forEach(function (list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-event-sort-item]'));
    items.sort(function (a, b) {
      var aDate = Date.parse(a.getAttribute('data-event-start') || '');
      var bDate = Date.parse(b.getAttribute('data-event-start') || '');
      if (Number.isNaN(aDate)) aDate = Number.POSITIVE_INFINITY;
      if (Number.isNaN(bDate)) bDate = Number.POSITIVE_INFINITY;
      return aDate - bDate;
    });

    function arrangeItems() {
      var arranged = phoneMedia.matches ? compactMobileTileOrder(items) : items;
      arranged.forEach(function (item) { list.appendChild(item); });
    }

    items.forEach(function (item) {
      var serverRatio = Number(item.getAttribute('data-media-aspect-ratio'));
      if (serverRatio > 0) applyTileFormat(item, serverRatio);

      var media = item.querySelector('video, img');
      if (!media) return;

      function updateFromIntrinsicSize() {
        var width = media.videoWidth || media.naturalWidth || 0;
        var height = media.videoHeight || media.naturalHeight || 0;
        if (width > 0 && height > 0 && applyTileFormat(item, width / height)) arrangeItems();
      }

      if (media.tagName === 'VIDEO') {
        media.addEventListener('loadedmetadata', updateFromIntrinsicSize, { once: true });
        if (media.readyState >= 1) updateFromIntrinsicSize();
      } else {
        media.addEventListener('load', updateFromIntrinsicSize, { once: true });
        if (media.complete) updateFromIntrinsicSize();
      }
    });

    arrangeItems();
    if (phoneMedia.addEventListener) phoneMedia.addEventListener('change', arrangeItems);
    else phoneMedia.addListener(arrangeItems);
  });
})();
